import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'mark-query',
  templateUrl: 'mark-query.html',
  styleUrls: ['mark-query.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MarkQueryComponent {

  @Input() public text: string = '';
  @Input() public query: string = '';

  constructor(
  ) { }

  public get marked(): string {
    return this.query == '' ? this.text : this.text.replace(new RegExp('('+this.query+')', 'i'), '<span class="mq">\$1</span>');
  }

}
